import _ from 'lodash'
import qs from 'qs'
import { push } from 'react-router-redux'
import { toast } from 'react-toastify'
import { saveAs } from 'file-saver'

import api from '../lib/api'

export const CREATE_DEFECT_SUCCESS = 'CREATE_DEFECT_SUCCESS'
export const CREATE_DEFECT_FAILURE = 'CREATE_DEFECT_FAILURE'
export const UPDATE_DEFECT_SUCCESS = 'UPDATE_DEFECT_SUCCESS'
export const UPDATE_DEFECT_FAILURE = 'UPDATE_DEFECT_FAILURE'
export const READ_DEFECT_SUCCESS = 'READ_DEFECT_SUCCESS'
export const READ_DEFECT_FAILURE = 'READ_DEFECT_FAILURE'
export const LIST_DEFECTS_SUCCESS = 'LIST_DEFECTS_SUCCESS'
export const LIST_DEFECTS_FAILURE = 'LIST_DEFECTS_FAILURE'
export const CLEAR_DEFECT_SUCCESS = 'CLEAR_DEFECT_SUCCESS'
export const SET_DEFECT_ERRORS_SUCCESS = 'SET_DEFECT_ERRORS_SUCCESS'
export const CLEAR_DEFECT_ERRORS_SUCCESS = 'CLEAR_DEFECT_ERRORS_SUCCESS'
export const SET_DEFECT_CURRENT_FIELD_SUCCESS = 'SET_DEFECT_CURRENT_FIELD_SUCCESS'

export const createDefect = (defect, images = []) => async dispatch => {
  try {
    defect = _.omit(defect, ['authorUser', 'assigneeUser', 'project', 'defectArea', 'commentSummary', 'defectImages'])
    const formData = new FormData()
    _.forOwn(defect, (value, key) => {
      if (value) {
        formData.append(key, value)
      }
    })
    _.forEach(images, (image) => {
      formData.append('images', image)
    })
    await api.post('/api/defects', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    await dispatch({ type: CREATE_DEFECT_SUCCESS })
    dispatch(push('/defect'))
  } catch (err) {
    toast.error('Failed to create a defect.')
    console.log(err.msg)
    dispatch({ type: CREATE_DEFECT_FAILURE, err })
  }
}
export const updateDefect = (defect) => async dispatch => {
  try {
    defect = _.omit(defect, ['authorUser', 'assigneeUser', 'project', 'defectArea', 'commentSummary', 'defectImages'])
    await api.put(`/api/defects/${defect.id}`, defect)
    await dispatch({ type: UPDATE_DEFECT_SUCCESS })
    dispatch(push('/defect'))
  } catch (err) {
    toast.error('Failed to update the defect.')
    console.log(err.msg)
    dispatch({ type: UPDATE_DEFECT_FAILURE, err })
  }
}

export const readDefect = (defectId) => async dispatch => {
  try {
    dispatch({ type: CLEAR_DEFECT_SUCCESS })
    const { data } = await api.get(`/api/defects/${defectId}`)
    dispatch({ type: READ_DEFECT_SUCCESS, data: { current: data } })
  } catch (err) {
    toast.error('Failed to retrieve the defect.')
    console.log(err.msg)
    dispatch({ type: READ_DEFECT_FAILURE, err })
  }
}

export const listDefects = (query) => async dispatch => {
  try {
    const defaultQuery = { limit: process.env.REACT_APP_PAGE_LIMIT, page: 1 }
    const { data } = await api.get(`/api/defects?${qs.stringify(_.merge(defaultQuery, query))}`)
    dispatch({ type: LIST_DEFECTS_SUCCESS, data: { query, list: data } })
  } catch (err) {
    toast.error('Failed to retrieve the list of the defects.')
    console.log(err.msg)
    dispatch({ type: LIST_DEFECTS_FAILURE, err })
  }
}

export const getPdf = (query) => async dispatch => {
	const response = await api.get(`/api/report?${qs.stringify(query)}`, {
		responseType: 'blob'
  })

	const blob = new Blob([response.data], {
		type: 'application/pdf',
	});
	saveAs(blob, 'defect.pdf');
}

export const setDefectErrors = (errors) => dispatch => {
  dispatch({ type: SET_DEFECT_ERRORS_SUCCESS, data: { errors } })
}

export const clearDefectErrors = () => dispatch => {
  dispatch({ type: CLEAR_DEFECT_ERRORS_SUCCESS })
}

export const setDefectCurrentField = (field, value) => dispatch => {
  dispatch({ type: SET_DEFECT_CURRENT_FIELD_SUCCESS, data: { field, value } })
}


// WEBPACK FOOTER //
// ./src/actions/defect.js